import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4630166a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630166a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4630166a')) {
      api.createRecord('4630166a', component.options)
    } else {
      api.reload('4630166a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4630166a&scoped=true&", function () {
      api.rerender('4630166a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/index.vue"
export default component.exports